import {
  IconBuilding,
  IconKindergarten,
  IconMall,
  IconPark,
  IconPlayground,
} from 'components/icons';
import { Layout } from 'components/layout';
import React from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../carousel/carousel';

export const NewMoscow = () => {
  const plansList = [
    {
      icon: <IconPark />,
      title: 'открытие индустриального парка',
    },
    {
      icon: <IconBuilding />,
      title: 'строительство МФК с центром Госуслуг',
    },
    {
      icon: <IconKindergarten />,
      title: 'строительство образовательного комплекса',
    },
    {
      icon: <IconPlayground />,
      title: 'строительство детского сада',
    },
    {
      icon: <IconMall />,
      title: 'строительство торгового центра',
    },
  ];

  return (
    <section className="font-open-sans">
      <Layout.Container>
        <div className="mt-[14px] mb-[52px] px-[33px]">
          <h3 className="text-plt-black font-bold text-[32px] text-center screen-700:text-lg">
            Новая Москва - территория развития
          </h3>
          <p className="text-center max-w-[948px] mx-auto font-semibold text-xl leading-[120%] mt-10 screen-700:mt-6 screen-700:text-sm screen-700:font-normal">
            Новая Москва активно развивается. Ежегодно строятся объекты жилой,
            социальной и коммерческой инфраструктуры, что позволяет все большему
            количеству ее жителей переходить на новые места работы, открывать
            собственный бизнес и получать необходимые услуги в своем городском
            округе.
          </p>
          <p className="text-center max-w-[948px] mx-auto font-semibold text-xl leading-[120%] mt-5 screen-700:mt-2 screen-700:text-sm screen-700:font-normal">
            На сегодняшний день в п. Крекшино и рядом со станцией «Санино»
            запланировано:
          </p>
          <div className="grid grid-cols-5 gap-5 mt-10 screen-1150:hidden">
            {plansList.map((item) => (
              <div
                key={item.title}
                className="py-5 px-3 rounded-[20px] shadow-xl"
              >
                <div className="w-fit mx-auto">{item.icon}</div>
                <p className="text-center mt-6 text-plt-black font-semibold">
                  {item.title}
                </p>
              </div>
            ))}
          </div>
          <div className="px-[66px] mt-6 hidden screen-1150:block screen-500:px-[50px]">
            <Carousel opts={{ align: 'start' }}>
              <CarouselContent>
                {plansList.map((item) => (
                  <CarouselItem
                    key={item.title}
                    className="basis-1/3 screen-950:basis-1/3 screen-750:basis-1/2 screen-550:basis-full py-3 h-full"
                  >
                    <div
                      key={item.title}
                      className="py-5 px-3 rounded-[20px] shadow-xl screen-1150:shadow-md min-h-[200px]"
                    >
                      <div className="w-fit mx-auto">{item.icon}</div>
                      <p className="text-center mt-6 text-plt-black font-semibold">
                        {item.title}
                      </p>
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
              <div className="hidden screen-1150:flex justify-center gap-2 mt-9">
                <CarouselPrevious className="static size-[56px] border-plt-secondary border-2" />
                <CarouselNext className="static size-[56px] border-plt-secondary border-2" />
              </div>
            </Carousel>
          </div>
        </div>
      </Layout.Container>
    </section>
  );
};
